// The messaging area's ONE mutation-failure note — the sales/waste task-#105
// extraction, re-owned here because those copies are hard-wired to their own
// namespaces and area classes (each area owns its own; a cross-area import
// would be module 17's refusals styled by module 09's stylesheet).
//
// Three facts, in order: the area's own sentence naming the failed verb
// (already translated), the SERVER's problem title verbatim behind
// `messaging.common.serverSaid` (D-022 — never a paraphrase), and the request
// id for support. The server title renders ONLY when the body really was a
// problem: `RequestError.message` falls back to the hook's English label, and
// printing that would dress a network cut as a server sentence.
//
// Callers keep PER-VERB error state and reset siblings on every press — at
// most one note on the glass, and it is always the CURRENT claim.

import { useTranslation } from "react-i18next";
import { RequestError, requestIdOf } from "../../../lib/request";

export function MutationFailureNote({
  text,
  error,
  "data-testid": testId,
}: {
  text: string;
  error: unknown;
  "data-testid"?: string;
}) {
  const { t } = useTranslation();
  const requestId = requestIdOf(error);
  const serverTitle = error instanceof RequestError ? error.problem?.title : undefined;
  return (
    <p className="msg-error-note" role="alert" data-testid={testId}>
      {text}
      {serverTitle !== undefined && serverTitle.length > 0 ? (
        <> {t("messaging.common.serverSaid", { title: serverTitle })}</>
      ) : null}
      {requestId !== undefined ? (
        <>
          {" "}
          {t("messaging.common.requestId")}: <code>{requestId}</code>
        </>
      ) : null}
    </p>
  );
}
